import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TextField, InputAdornment } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E5BE80', // Default outline color
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E5BE80', // Outline color when hovered
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E5BE80', // Outline color when focused
          },
        },
      },
    },
  },
});

const Searchbar = () => {
  const [searchValue, setSearchValue] = React.useState('');
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get('q') || '';
    if (location.pathname === '/search') {
      setSearchValue(q);
    } else {
      setSearchValue('');
    }
  }, [location]);

  const handleSearch = () => {
    if (searchValue.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchValue.trim())}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <TextField
        id="outlined-basic"
        variant="outlined"
        placeholder="Search Products"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyPress={handleKeyPress}
        autoComplete="off"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon 
                sx={{ cursor: 'pointer' }} 
                onClick={handleSearch}
              />
            </InputAdornment>
          ),
        }}
        sx={{
          height: '40px',
          width: { xs: '150px', sm: '250px', md: '300px' },
          '& .MuiOutlinedInput-root': { height: '40px', borderRadius: '100px' },
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px white inset',
            transition: 'background-color 5000s ease-in-out 0s',
          },
        }} // Adjust height here
      />
    </ThemeProvider>
  );
};

export default Searchbar;
